module.exports = __webpack_public_path__ + "img/snl-wc.78d9b0dc.png";